import {Component, Input, OnInit} from '@angular/core';
import {Helper} from '../../../utils/helper.module';
import {environment} from "../../../../environments/environment";
import {HttpClient} from "@angular/common/http";

@Component({
    selector: 'app-reset-form',
    templateUrl: './reset-form.component.html',
    styleUrls: ['./reset-form.component.css']
})
export class ResetFormComponent implements OnInit {
    submitted = false;
    onloading = false;
    welDone : any = null;
    errorMsg = '';
    user : any = {};
    @Input() isShoppingFunnel : any = false;
    logoName:any;
    modePro: boolean;

    constructor(private http: HttpClient){
      this.modePro = environment.pro;
      //pro is using old template like shoppingtunnel,it is patching
      this.isShoppingFunnel = environment.pro;
    }

    ngOnInit(){
      this.logoName = (this.modePro) ? 'logo-pro.png' : 'logo.png';
    }

    onSubmit() {
      let vm = this;
      this.onloading = true;
      this.sendMail().then(function(rsp:any){
          vm.onloading = false;
          vm.welDone = rsp.state;
      });
    }

    sendMail(){ // envoie par la méthode post
        console.log(this.user) // users/forget-password
        return this.http.post(Helper.api('users/forget-password'), this.user) //send the mail
            .toPromise()
            .then((response) => {
                Promise.resolve(response);
                return Promise.resolve(response);
            }).catch();
    }

}
